export default __webpack_public_path__ + "static/media/profits.88d45827.svg";